/* Copyright (c) 2026 Xperi. All Rights Reserved. */

/**
 * Resolves the build environment the feature resolver reasons about.
 *
 * Mapped directly off the `__DEV_TOOLS_ENABLED__` DefinePlugin flag (the same
 * flag `isDevToolsBuild()` reads): a debug/dev-tools build is `DEVELOPMENT`,
 * every release build is `PRODUCTION`. The flag is read here rather than via
 * `src/devtools` so the model layer stays free of a `model → devtools → model`
 * import cycle. In a release build the compiler pins this to a constant
 * `PRODUCTION`, so no development/testing stage can ever become visible.
 */

import { BuildEnvironment } from "./types";

declare const __DEV_TOOLS_ENABLED__: boolean;

export function resolveBuildEnvironment(): BuildEnvironment {
  let isDevToolsBuild: boolean = false;
  try {
    isDevToolsBuild =
      typeof __DEV_TOOLS_ENABLED__ !== "undefined" &&
      __DEV_TOOLS_ENABLED__ === true;
  } catch {
    isDevToolsBuild = false;
  }
  return isDevToolsBuild
    ? BuildEnvironment.DEVELOPMENT
    : BuildEnvironment.PRODUCTION;
}
